import Placement from './Placement.graphql';

const PlacementQuery = Placement;

export { PlacementQuery };
